/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports({
    since,
    until,
    businessHours,
    excludeIssueTime,
    inboxIds,
  } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/team`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        exclude_issue_time: excludeIssueTime,
        timezone_offset: getTimeOffset(),
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }

  getVipReports({ since, until, businessHours, inboxIds } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/vip`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }

  getVipAgentReports({
    since,
    until,
    businessHours,
    excludeIssueTime,
    inboxIds,
  } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/vip_agents`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        exclude_issue_time: excludeIssueTime,
        timezone_offset: getTimeOffset(),
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }

  getAgentReports({
    since,
    until,
    businessHours,
    excludeIssueTime,
    inboxIds,
  } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        exclude_issue_time: excludeIssueTime,
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }

  // Get individual sessions for a specific agent (for QA drill-down)
  getAgentSessions({
    userId,
    since,
    until,
    businessHours,
    metricFilter,
    threshold,
    thresholdMax,
    thresholdOperator,
    inboxId,
    sortDirection,
    page,
    perPage,
  } = {}) {
    return axios.get(`${this.url}/agent_sessions`, {
      params: {
        user_id: userId,
        since,
        until,
        business_hours: businessHours,
        metric_filter: metricFilter,
        threshold,
        threshold_max: thresholdMax,
        threshold_operator: thresholdOperator,
        inbox_id: inboxId,
        sort_direction: sortDirection,
        page,
        per_page: perPage,
      },
    });
  }

  getInboxReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getLabelReports({ since, until, businessHours, inboxIds } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/label`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }

  getIssueAgentReports({ since, until, inboxIds } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/issue_agents`, {
      params: {
        since,
        until,
        timezone_offset: getTimeOffset(),
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }

  getIssueTypeReports({ since, until, inboxIds } = {}) {
    const normalizedInboxIds = Array.isArray(inboxIds)
      ? inboxIds.map(Number).filter(Boolean)
      : [];
    return axios.get(`${this.url}/issue_types`, {
      params: {
        since,
        until,
        timezone_offset: getTimeOffset(),
        ...(normalizedInboxIds.length > 0
          ? { inbox_ids: normalizedInboxIds.join(',') }
          : {}),
      },
    });
  }
}

export default new SummaryReportsAPI();
